import axios from 'axios';

import { restUrl } from '@/services/utils';

import {
    type DeleteItemsSelection,
    readSelectionId,
    restrictionQuery,
    selectionPayload,
} from './deleteItemsSelection';

const resolveSelectionId = async (selection: DeleteItemsSelection): Promise<string> => {
    const existing = readSelectionId(restrictionQuery(selection.itemsQuery));
    if (existing) {
        return existing;
    }

    const response = await axios.post<{ selectionId?: string }>(
        restUrl('selections'),
        selectionPayload(selection),
    );
    const selectionId = response.data?.selectionId;
    if (!selectionId) {
        throw new Error('NO_SELECTION_ID');
    }
    return selectionId;
};

const deleteItemsBySelectionId = async (selectionId: string): Promise<void> => {
    await axios.post(restUrl('deleteItems'), { selectionId });
};

export { deleteItemsBySelectionId, resolveSelectionId };
